package com.neurobs.ccabserver.translationadmin

import com.neurobs.ccab.IdentityData
import com.neurobs.ccabserver.translationadmin.components.testupload.TestUpload
import com.neurobs.ccabserver.translationadmin.components.translationprogress.TranslationProgress
import com.neurobs.ccabserver.translationadmin.states.{TestUploadStateProvider, TranslationProgressStateProvider}
import com.neurobs.react.semanticui.{UiDividerFactory, UiGridFactory}
import org.scalajs.dom
import org.scalajs.dom.raw.Element
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.{React, ReactElement}
import slinky.web.ReactDOM

class Main(targetDiv: Element, userData: IdentityData) {

  ReactDOM.render(
    TranslationAdmin(userData),
	  targetDiv
  )

}

@react
object TranslationAdmin {
  case class Props(userData: IdentityData)
  val component = FunctionalComponent[Props] { props =>

    val appHtml = Seq[ReactElement](
      UiDividerFactory.Horizontal,
      TestUpload(),
      UiDividerFactory.Horizontal,
      TranslationProgress()
//      UiGridFactory.Grid(
//        UiGridFactory.GridColumn(
//
//        )("sixteen wide"),
//        UiGridFactory.GridColumn(
//
//        )("sixteen wide")
//    )
    )

    TestUploadStateProvider(
      TranslationProgressStateProvider(
        children = appHtml:_*
      )
    )


  }
}
